var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teams---single-user",
    transform: "translate(-193.000000, -595.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-amex",
    transform: "translate(193.000000, 595.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,17.3333333 C28,18.806 26.806,20 25.3333333,20 L2.66666667,20 C1.194,20 0,18.806 0,17.3333333 L0,2.66666667 C0,1.194 1.194,0 2.66666667,0 L25.3333333,0 C26.806,0 28,1.194 28,2.66666667 L28,17.3333333 Z",
    id: "Path",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.666667, 7.333333)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.17,0 L8.76133333,3.122 L7.35933333,0 L5.56266667,0 L5.56266667,4.484 L3.56066667,0 L2.04466667,0 L0,4.654 L1.21,4.654 L1.65733333,3.61533333 L3.94533333,3.61533333 L4.4,4.654 L6.71,4.654 L6.71,1.19733333 L8.24266667,4.654 L9.28466667,4.654 L10.852,1.25733333 L10.852,4.654 L12,4.654 L12,0 L10.17,0 Z M2.09,2.61 L2.774,0.983333333 L3.48466667,2.61 L2.09,2.61 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5886667,2.27533333 L22.6666667,0.012 L21.1886667,0.012 L19.8593333,1.45466667 L18.5733333,0 L14,0 L14,4.65466667 L18.4233333,4.65466667 L19.818,3.114 L21.178,4.66666667 L22.6513333,4.66666667 L20.5886667,2.27533333 Z M17.8186667,3.67733333 L15.1446667,3.67733333 L15.1446667,2.75666667 L17.7033333,2.75666667 L17.7033333,1.87466667 L15.1446667,1.87466667 L15.1446667,1.00266667 L17.9673333,1.01066667 L19.096,2.27533333 L17.8186667,3.67733333 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmex);
export default __webpack_public_path__ + "static/media/icon-amex.b425e160e9a61759cae26f3b8902967b.svg";
export { ForwardRef as ReactComponent };